import React from "react";
import { FaCheck } from "react-icons/fa";
import { Card, CardBody, CardHeader } from "reactstrap";
import { Button, DefaultSelect } from "ui-kit-takeat";

const PROVIDER_OPTIONS = [
  {
    label: "Chatwoot",
    value: "chatwoot",
  },
  {
    label: "Hubspot",
    value: "hubspot",
  },
];

export const ChatProviderCard = ({
  chatProvider,
  setChatProvider,
  handleUpdate,
}) => {
  return (
    <Card>
      <CardHeader>
        <h2 style={{ fontSize: 16, margin: 0, fontWeight: 600 }}>
          Provedor de chat
        </h2>
      </CardHeader>
      <CardBody style={{ display: "flex", gap: 8 }}>
        <DefaultSelect
          name="provider"
          options={PROVIDER_OPTIONS}
          value={PROVIDER_OPTIONS.find(
            (option) => option.value === chatProvider
          )}
          onChange={(e) => setChatProvider(e.value)}
        />
        <Button
          icon={<FaCheck />}
          buttonColor="#6bd098"
          disabled={!chatProvider}
          onClick={() => handleUpdate(chatProvider)}
        />
      </CardBody>
    </Card>
  );
};
